import { ArrowRight } from "lucide-react";
import type React from "react";

import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";

interface WizardActionsProps {
	onCancel: () => void;
	onContinue: () => void;
	canContinue: boolean;
}

export const WizardActions: React.FC<WizardActionsProps> = ({
	onCancel,
	onContinue,
	canContinue,
}) => {
	const t = useTranslations("builder");
	return (
	<div className="flex flex-wrap justify-end">
		<Button className="flex-grow" onClick={onCancel} variant="outline">
			{t("cancel")}
		</Button>
		<Button
			className="flex flex-grow items-center gap-2"
			disabled={!canContinue}
			onClick={onContinue}
		>
			{t("continue")}
			<ArrowRight className="size-4" />
		</Button>
	</div>
	);
};
